import { render } from "./CIS-InfoHub.vue?vue&type=template&id=af689762"
import script from "./CIS-InfoHub.vue?vue&type=script&lang=js"
export * from "./CIS-InfoHub.vue?vue&type=script&lang=js"

import "./CIS-InfoHub.vue?vue&type=style&index=0&id=af689762&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__